<template>
  <div
    class="auth-layout px-6 py-12 md:h-screen md:px-12 lg:flex lg:items-center lg:justify-center lg:px-20"
  >
    <div class="auth-wrapper">
      <div class="flex flex-wrap shadow">
        <div class="h-40 w-full bg-blue-50 lg:h-auto lg:w-6/12">
          <Image
            src="/images/layouts/auth/banner.jpeg"
            alt="Image"
            image-style="width: 100%; height: 100%; object-fit: cover;"
          />
        </div>

        <div class="bg-surface-0 dark:bg-surface-900 w-full p-12 lg:w-6/12 lg:p-16">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.auth-wrapper {
  max-width: map-get(map-get($breakpoints, xl), min);
}
</style>
